// @ts-ignore
const userAgent = navigator.wxuserAgent || navigator.userAgent;
/**
 * 比较版本1和版本2的高低, 0 相等，-1 v1 < v2， 1 v1 > v2
 * @param v1 版本1
 * @param v2 版本2
 */
export function verCompare(v1: string, v2: string) {
  const v1Arr = v1.split('.');
  const v2Arr = v2.split('.');
  const len = Math.max(v1Arr.length, v2Arr.length);

  while (v1Arr.length < len) {
    v1Arr.push('0');
  }
  while (v2Arr.length < len) {
    v2Arr.push('0');
  }

  for (let i = 0; i < len; i++) {
    const num1 = parseInt(v1Arr[i], 10);
    const num2 = parseInt(v2Arr[i], 10);

    if (num1 > num2) {
      return 1;
    } if (num1 < num2) {
      return -1;
    }
  }

  return 0;
}

/**
 * 获取微信版本
 */
function getWeixinVer() {
  // ...MicroMessenger/7.0.1380(0x2700003D)...获取(0x....)
  let pattern = /MicroMessenger\/[\d.]+\((.*)\)/i;
  let wc = userAgent.match(pattern);
  if (!wc) {
    pattern = /MicroMessenger\/([\d.]+)/i;
    wc = userAgent.match(pattern);
    if (wc) return wc[1];
  }
  if (!wc) return '0.0.0';
  const version = wc[1].slice(3);
  const result: number[] = [];
  result.push(parseInt(version.slice(0, 1), 16));
  result.push(parseInt(version.slice(1, 3), 16));
  result.push(parseInt(version.slice(3, 5), 16));
  return result.join('.') || '0.0.0';
}

/**
 * 比较微信版本大于等于ver
 * @param ver 比较的版本
 */
export function isWexinVerLargeOrEqualThan(ver: string) {
  const curVer = getWeixinVer();
  return verCompare(curVer, ver) > -1;
}

/**
 * 获取OS信息
 */
function getOSInfo() {
  let pattern = /iPhone OS ([\d_]+)/i;
  let wc = userAgent.match(pattern);
  if (wc) return { type: 'iphone', version: wc[1].replace('_', '.') };
  pattern = /Android ([\d.]+)/i;
  wc = userAgent.match(pattern);
  if (wc) return { type: 'android', version: wc[1] };
  return { type: 'none', version: '0.0.0' };
}

/**
 * 判断安卓、ios的版本是否大于等于指定版本
 * @param minVer 两个系统的最低版本
 */
export function isOSVerLargeOrEqualThan(minVer: {
  android?: string;
  iphone?: string;
}) {
  const { type, version } = getOSInfo();
  const ver = minVer[type];
  return verCompare(version, ver) > -1;
}


/**
 * 是否支持h5唤起小程序
 * 需要 weixin版本7.0.12及以上 IOS10.3及以上 Android5.0及以上
 * @export
 */
export function isSupportH5ToWeapp() {
  const version = '7.0.12';
  const wechat =  isWexinVerLargeOrEqualThan(version);
  const os = isOSVerLargeOrEqualThan({
    android: '5.0',
    iphone: '10.3',
  });
  return wechat && os;
}


